import {ContentListResponse} from "../../response/ContentListResponse";

export class UgcFeedData {

	posts: ContentListResponse;
	microblogposts: ContentListResponse;
	events: ContentListResponse;

}
